import { render, staticRenderFns } from "./HourlyEfficiency.vue?vue&type=template&id=f670018a"
import script from "./HourlyEfficiency.vue?vue&type=script&lang=js"
export * from "./HourlyEfficiency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f670018a')) {
      api.createRecord('f670018a', component.options)
    } else {
      api.reload('f670018a', component.options)
    }
    module.hot.accept("./HourlyEfficiency.vue?vue&type=template&id=f670018a", function () {
      api.rerender('f670018a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/kanbanPlatform/sortingDataMonitoring/components/HourlyEfficiency.vue"
export default component.exports